import { addItem, deleteItem } from './clock';
import { getCountdownVal } from './time';
/**
 * 倒计时类
 */
export class Countdown {
  startTime: Date; // 开始时间
  endTime: Date; // 结束时间
  interval: number; // 时间间隔
  listenFn: Function; // 监听函数
  diffTime = 0; // 本机时间和开始时间的diff
  day = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;
  constructor(startTime: Date, endTime: Date, interval = 1000, listenFn: Function) {
    this.startTime = startTime;
    this.endTime = endTime;
    this.interval = interval;
    this.listenFn = listenFn;
    this.diffTime = this.startTime.getTime() - Date.now();
    addItem(this);
  }

  run() {
    const endTime = this.endTime.getTime();
    const startTime = Date.now() + this.diffTime;
    const distance = endTime - startTime;
    const { day, hours, minutes, seconds } = getCountdownVal(distance);
    this.day = day;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
    if (Math.max(day, hours, minutes, seconds) === 0) {
      this.delete();
    }
    this.listenFn(this);
  }

  delete() {
    deleteItem(this);
  }
}
